class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.recommendationRequestId = 0;

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    );

    this.querySelectorAll('button[type="button"]').forEach(
      (closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    this.dispatchCartViewEvent();
  }

  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    try {
      const response = await fetch(`${routes.cart_url}.json`);
      if (!response.ok) return;

      const cart = await response.json();
      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (e) {
      // Tracking-Fehler dürfen den Warenkorb nicht blockieren.
    }
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    const recommendation = this.querySelector(
      '#fhx-cart-recommendation'
    );

    if (recommendation) {
      recommendation.hidden = true;
    }

    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
    });

    if (this.header) this.header.reveal();

    this.open();
    this.updateAccessoryRecommendation();
  }

  async updateAccessoryRecommendation() {
    const recommendation = this.querySelector(
      '#fhx-cart-recommendation'
    );

    if (!recommendation) return;

    recommendation.hidden = true;

    const requestedKey = this.cartItemKey;
    const requestId = ++this.recommendationRequestId;

    try {
      const response = await fetch(`${routes.cart_url}.js`, {
        headers: {
          Accept: 'application/json',
        },
        cache: 'no-store',
      });

      if (!response.ok) return;

      const cart = await response.json();

      if (requestId !== this.recommendationRequestId) return;
      if (requestedKey !== this.cartItemKey) return;
      if (!Array.isArray(cart.items)) return;

      const addedItem = cart.items.find(
        (item) => item.key === requestedKey
      );

      const accessoryAlreadyInCart = cart.items.some(
        (item) =>
          String(item.product_id) ===
          recommendation.dataset.productId
      );

      // Gilt für ASA und Carbon sowie alle Sturzpad-Längen.
      const addedCrashPad =
        addedItem &&
        /sturzpad/i.test(addedItem.product_title || '');

      recommendation.hidden =
        !addedCrashPad || accessoryAlreadyInCart;

      // Den Fokusbereich um die eingeblendeten Elemente erweitern.
      if (
        !recommendation.hidden &&
        this.notification.classList.contains('active')
      ) {
        const focusedElement = document.activeElement;

        if (this.notification.contains(focusedElement)) {
          trapFocus(this.notification, focusedElement);
        }
      }
    } catch (error) {
      if (requestId === this.recommendationRequestId) {
        recommendation.hidden = true;
      }
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {
      const disclosure = target.closest(
        'details-disclosure, header-menu'
      );

      this.activeElement = disclosure
        ? disclosure.querySelector('summary')
        : null;

      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
